import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import validator from "validator";
import {
  Container,
  Divider,
  Grid,
  Card,
  Paper,
  Input,
  Typography,
  form,
  TextField,
  Switch,
  FormHelperText,
  Button,
  InputLabel,
  Checkbox,
  FormControlLabel,
  Select,
  MenuItem,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  FormControl,
  DialogContentText,
  Box,
  InputAdornment,
  Menu,
  Chip,
  CircularProgress,
} from "@material-ui/core";
import RightIcon from "../../../../assests/images/Group 911.svg";
import Modal from "@material-ui/core/Modal";
import profile from "../../../../assests/images/profile/Group 1854.png";
import edit from "../../../../assests/images/profile/Group 1770.png";
import Email from "../../../../assests/images/profile/Path 2038.png";
import phone from "../../../../assests/images/profile/Path 2039.png";
import map from "../../../../assests/images/profile/Group 1771.png";
import LockResetIcon from "@mui/icons-material/LockReset";
import {
  countriesList,
  getuser,
  addProfileData,
  addProfileImage,
  removeAccount,
  getBusinessInfo,
  getaccountdetails,
  updateProfilePic,
} from "../actions/dashboardAction";
import getUserdetailsforsubscrption from "../../../pages/dashboard/actions/dashboardaapi";
import {
  getComponentActionList,
  isActionAllowed,
} from "../../../../common/components/Helper/Utils";
import {
  activePackageList,
  changedPassword,
} from "./../../dealer/actions/dealerAction";
import { data } from "jquery";
import profileimg from "../../../../../src/assests/images/profile/profile.png";
import { SpinnerRoundFilled } from "spinners-react";
import EditIcon from "@material-ui/icons/Edit";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { addDays, format } from "date-fns";
import RemoveAccountModal from "./RemoveAccountModal";
import ContentWrapper from "../../../../common/components/contentWrapper";
import LoadingSpinner from "@mui/material/CircularProgress";
import Cropper from "react-cropper";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import BusinessCreatemodel from "./NewBusinessCreate";
import "cropperjs/dist/cropper.css";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import addinvetrysearchdataa from "../../../pages/dashboard/actions/dashboardaapi";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import BeenhereIcon from "@mui/icons-material/Beenhere";
import LocalMallOutlinedIcon from "@mui/icons-material/LocalMallOutlined";
import VerifiedIcon from "@mui/icons-material/Verified";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../../common/components/Helper/Utils";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Tooltip } from "@mui/material";
import PubNub from "pubnub";
import "../style/style.css";
import { toast } from "react-toastify";
import constants from "../../../../utils/constants";
import { getBillingPlans } from "../../administration/actions/administration";
import EbaySettings from "../../administration/ebaySettings";
class ProfileComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      openPasswordDialog: false,
      showPassword: {
        current: false,
        new: false,
        confirm: false,
      },
      form: {
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      edit: "",
      editable: false,
      editable1: false,
      disbleeditbtn: true,
      disbleeditbtn1: true,
      disbledntn: false,
      disbledntn1: false,
      isDisabled: true,
      isDisabled1: true,
      isSavingBusiness: false,
      isSavingBusiness1: false,
      isSavingProfile: false,
      isSavingProfile1: false,
      isLoading: false,
      firstName: "",
      businessName: "",
      lastName: "",
      emailId: "",
      loading: false,
      phoneNumber: "",
      DOB: "",
      gender: "",
      countryCode: "+1",
      statesListData: [],
      country: "",
      city: "",
      statename: "",
      zipCode: "",
      zelleInfo: "",
      venmoInfo: "",
      profilePic: "",
      UploadPic: "",
      profilePicLocal: "/static/media/Group 1854.82be9dbe.png",
      addressLine1: "",
      addressLine2: "",
      bankName: "",
      accountNumber: "",
      achRouting: "",
      wireRouting: "",
      swiftCode: "",
      businessStreetAddress: "",
      onFirstNameErrorText: "",
      onLastNameErrorText: "",
      onEmailIdErrorText: "",
      onPhoneNumberErrorText: "",
      onCountryCodeErrorText: "",
      onDobErrorText: "",
      onGenderErrorText: "",
      onCountryErrorText: "",
      onCityErrorText: "",
      onZelleErrorText: "",
      onVenmoErrorText: "",
      onStateErrorText: "",
      onZipCodeErrorText: "",
      onBusinessNameErrorText: "",
      onMessageErrorText: "",
      onAddressErrorText: "",
      onUploadPicErrorText: "",
      ontaxIdErrorText: "",
      onSwiftCodeErrorText: "",
      onWireRoutingErrorText: "",
      onAccountNumberErrorText: "",
      onAccountNameErrorText: "",
      onBankNameErrorText: "",
      onAchRoutingErrorText: "",
      loaded: false,
      countryListData: [],
      statesListData: [],
      uniqueCountryCode: [],
      UploadPic1: "",
      onUploadLogoErrorText: "",
      uploadLogo: "",
      isLogoValid: "",
      files: "",
      accessData: [],
      errors: {},
      accountId: "",
      tax_id: "",
      accountName: "",
      log_url: "",
      src: null,
      cropResult: null,
      accountDisabled:
        JSON.parse(window.sessionStorage.getItem("userDetails"))?.accountdetails
          ?.length == 1
          ? true
          : false,
      accountbusinessId: window.sessionStorage.getItem("accountId"),
      createEnable: false,
      openShopifyDialog: false,
      openSetupModal: false,
      handleCloseShopifyDialog: false,
      shopname: "",
      shopify_client_id: "",
      shopify_client_secret: "",
      isValidatingShopify: false,
      isValidatingQuickbook: false,
      isQuickbookConnected: false,
      showShopifySuccess: false,
      accessToken: "",
      isDisabled: true,
      tempShopName: "",
      tempClientId: "",
      tempSecretId: "",
      // tempAccessToken: '',
      showAccessToken: false,
      showClientId: false,
      showSecretId: false,
      isValidated: false,
      needsShopifyApproval: false,
      billingPlansFetched: false,
      isQuickbookValidated: false,
      showValidationFields: false,
      shopifyEmail: "",
      shopifyUrl: "",
      quickBookName: "",
      quickBookEmail: "",
      shopifyDomain: "",
      anchorEl: null,
      hideSetupBtn: false,
      isShopifyEnabled:
        window.sessionStorage.getItem("isShopifyEnabled") === "true",
      isQboEnabled: window.sessionStorage.getItem("isQboEnabled") === "true",
      isEbayEnabled: window.sessionStorage.getItem("isEbayEnabled") === "true",
    };
    this.pubnub = new PubNub({
      publishKey: constants.PUBNUB_PUBLISHKEY,
      subscribeKey: constants.PUBNUB_SUBSCRIBEKEY,
      uuid: constants.PUBNUB_UUID,
      autoNetworkDetection: true,
      restore: true,
    });
    this._pubnubListener = null;
    this._pubnubSubscribedShopify = false;
    this._pubnubSubscribedQuickbook = false;
    this._pubnubShopifyListener = null;
    this._pubnubQuickbookListener = null;
    const { history, currentUser, logoutAction } = props;

    this.cropperRef = React.createRef();

    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.handleOpenPasswordDialog = this.handleOpenPasswordDialog.bind(this);
    this.handleClosePasswordDialog = this.handleClosePasswordDialog.bind(this);

    this.onChangeOfFirstName = this.onChangeOfFirstName.bind(this);
    this.onChangeOfLastName = this.onChangeOfLastName.bind(this);
    this.onChangeOfPhoneNumber = this.onChangeOfPhoneNumber.bind(this);
    this.onChangeOfEmailId = this.onChangeOfEmailId.bind(this);
    this.onChangeOfCountry = this.onChangeOfCountry.bind(this);
    this.onChangeOfCity = this.onChangeOfCity.bind(this);
    this.onChangeOfState = this.onChangeOfState.bind(this);
    this.handleLoader = this.handleLoader.bind(this);
    this.handleCloseBusinessCreate = this.handleCloseBusinessCreate.bind(this);
    // this.onChangeOfZipcode = this.onChangeOfZipcode.bind(this);
    this.updatepackage = this.updatepackage.bind(this);
    this.onChangeOfAddressLine1 = this.onChangeOfAddressLine1.bind(this);
    this.onChangeOfAddressLine2 = this.onChangeOfAddressLine2.bind(this);
    this.validateInput = this.validateInput.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.togglePassword = this.togglePassword.bind(this);
    this.handleSubmitPassword = this.handleSubmitPassword.bind(this);
    this.UploadPhoto = this.UploadPhoto.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.getcountryList = this.getcountryList.bind(this);
    this.getStatesList = this.getStatesList.bind(this);
    this.onChangeOfbankName = this.onChangeOfbankName.bind(this);
    this.onChangeOfaccountNumber = this.onChangeOfaccountNumber.bind(this);
    this.onChangeOfaccountName = this.onChangeOfaccountName.bind(this);
    this.onChangeOfachRouting = this.onChangeOfachRouting.bind(this);
    this.onChangeOfwireRouting = this.onChangeOfwireRouting.bind(this);
    this.onChangeOfswiftCode = this.onChangeOfswiftCode.bind(this);
    this.onChangeOfTaxId = this.onChangeOfTaxId.bind(this);
    this.submitForm1 = this.submitForm1.bind(this);
    this.validateInput1 = this.validateInput1.bind(this);
  }
  componentWillMount() {}
  componentDidMount() {
    this.loadingApi();
    this.syncShopifySession();
    this.syncQuickbookSession();
    window.addEventListener("message", this.handleShopifyPopupMessage);
    window.addEventListener(
      "watchops-scroll-shopify",
      this.handleScrollToShopifyEvent,
    );
  }

  extractCompanyFromResponse(res) {
    try {
      const maybe =
        res && res.data && res.data.data
          ? res.data.data
          : res && res.data
            ? res.data
            : res;
      if (!maybe) return null;
      let company =
        maybe.company_data || maybe.Company || maybe.company || maybe;
      if (company && company.company_data) company = company.company_data;
      return company;
    } catch (e) {
      return null;
    }
  }

  componentWillUnmount() {
    try {
      window.removeEventListener("message", this.handleShopifyPopupMessage);
    } catch (e) {}
    try {
      window.removeEventListener(
        "watchops-scroll-shopify",
        this.handleScrollToShopifyEvent,
      );
    } catch (e) {}
    try {
      if (this._shopifyPopupCloseTimer) {
        clearTimeout(this._shopifyPopupCloseTimer);
      }
    } catch (e) {}
    try {
      if (this._pubnubListener)
        this.pubnub.removeListener(this._pubnubListener);
    } catch (e) {}
    try {
      if (this._pubnubShopifyListener)
        this.pubnub.removeListener(this._pubnubShopifyListener);
    } catch (e) {}
    try {
      if (this._pubnubQuickbookListener)
        this.pubnub.removeListener(this._pubnubQuickbookListener);
    } catch (e) {}
    try {
      const channels = [];
      if (this._pubnubSubscribedShopify) channels.push("shopify-notify");
      if (this._pubnubSubscribedQuickbook) channels.push("quickbook-notify");
      if (channels.length) this.pubnub.unsubscribe({ channels });
    } catch (e) {}
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.accountDetails !== this.props.accountDetails) {
      this.syncShopifySession();
      this.syncQuickbookSession();
    }
    if (this.state.isValidated && !this.state.billingPlansFetched) {
      this.fetchShopifyBillingNeeds();
    }
    if (
      this.state.loaded &&
      !prevState.loaded &&
      this.shouldScrollToShopify()
    ) {
      this.scrollToShopifySection();
    }
    if (
      this.props.location?.search !== prevProps.location?.search &&
      this.shouldScrollToShopify()
    ) {
      this.scrollToShopifySection();
    }
  }

  handleScrollToShopifyEvent = () => {
    this.scrollToShopifySection(true);
  };

  shouldScrollToShopify = () => {
    const params = new URLSearchParams(
      this.props.location?.search || window.location.search,
    );
    return params.get("scroll") === "shopify";
  };

  scrollToShopifySection = (force = false) => {
    if (!force && !this.shouldScrollToShopify()) return;
    if (!this.state.loaded) {
      if (force || this.shouldScrollToShopify()) {
        setTimeout(() => this.scrollToShopifySection(force), 200);
      }
      return;
    }

    const attemptScroll = (retriesLeft = 8) => {
      const el = document.getElementById("shopify-information");
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        if (!force) {
          const params = new URLSearchParams(window.location.search);
          params.delete("scroll");
          const query = params.toString();
          const nextUrl = `${window.location.pathname}${query ? `?${query}` : ""}`;
          window.history.replaceState({}, "", nextUrl);
        }
        return;
      }
      if (retriesLeft > 0) {
        setTimeout(() => attemptScroll(retriesLeft - 1), 150);
      }
    };

    setTimeout(() => attemptScroll(), 100);
  };

  fetchShopifyBillingNeeds = () => {
    this.setState({ billingPlansFetched: true });
    getBillingPlans((err, res) => {
      if (res?.success === 1) {
        this.setState({
          needsShopifyApproval: !!res.data?.needsShopifyApproval,
        });
      }
    });
  };

  handleGoToBilling = () => {
    if (this.props.history) {
      this.props.history.push("/administration?tab=billing");
    } else {
      window.location.href = "/administration?tab=billing";
    }
  };

  syncShopifySession = () => {
    const details = this.props.accountDetails;
    if (!details) return;
    const isVerified =
      details.isShopifyVerified === true ||
      details.is_shopify_verified === 1 ||
      details.shopify_verified === "Y";
      sessionStorage.setItem("isShopifyVerified", isVerified ? "true" : "false");
      this.setState({ isShopifyVerified: !!isVerified });
  };

  syncQuickbookSession = () => {
    const details = this.props.accountDetails;
    if (!details) return;
    const isVerified =
      details.isQboVerified === true ||
      details.is_quickbook_verified === 1 ||
      details.quickbook_verified === "Y";
    if (isVerified) {
      sessionStorage.setItem("isQboVerified", "true");
      this.setState({ isQboVerified: true });
    }
  };

  loadingApi = () => {
    const accessData = getComponentActionList("my_profile");
    const userDetails = window.sessionStorage.getItem("userDetails");
    const UserId = JSON.parse(userDetails).userId;
    const userDetails1 = window.sessionStorage.getItem("userDetails")
      ? JSON.parse(window.sessionStorage.getItem("userDetails"))
      : null;
    const accountId = userDetails1.accountId;
    this.setState({ accountId: this.state.accountbusinessId });
    this.setState({ accessData: accessData });
    setTimeout(() => {
      this.setState({ loaded: true });
    }, 500);
    this.props.activePackageList();
    this.getcountryList();
    if (this.props.currentUser) {
      const payload = {
        userId: UserId,
        accountId: this.state.accountbusinessId,
      };
      this.props.getaccountdetails(payload);
    }
  };

  handleMessage = (event) => {
    if (event?.channel === "shopify-notify") {
      this.loadingApi();
      let msg = event?.message;
      if (typeof msg === "string") {
        try {
          msg = JSON.parse(msg);
        } catch (e) {
          msg = {};
        }
      }
      if (msg?.type !== "SHOPIFY_FAILED") {
        this.scheduleCloseShopifyPopup();
      }
    }
  };

  handleShopifyPopupMessage = (event) => {
    if ((event?.data?.type === "SHOPIFY_VERIFIED" || event?.data?.type === "SHOPIFY_APP_INSTALLED") &&event?.data?.status === "success") {
      this.scheduleCloseShopifyPopup();
      this.loadingApi();
    }
  };

  scheduleCloseShopifyPopup = () => {
    if (this._shopifyPopupCloseTimer) {
      clearTimeout(this._shopifyPopupCloseTimer);
    }
    this._shopifyPopupCloseTimer = setTimeout(() => {
      this.closeShopifyPopup();
    }, 2000);
  };

  closeShopifyPopup = () => {
    // Try stored reference first
    try {
      if (this._shopifyPopup && !this._shopifyPopup.closed) {
        this._shopifyPopup.close();
      }
    } catch (e) {}

    // Re-acquire by window name (works even if original ref was lost after Shopify redirect)
    try {
      const namedPopup = window.open("", "shopifyAppSetup");
      if (namedPopup && !namedPopup.closed) {
        namedPopup.close();
      }
    } catch (e) {}

    this._shopifyPopup = null;
  };

  handleMessageQuick = (event) => {
    if (event?.channel === "quickbook-notify") {
      this.loadingApi();
    }
  };

  cropImage = (e) => {
    e.preventDefault();
    if (this.cropperRef.current) {
      const cropper = this.cropperRef.current.cropper;
      cropper.getCroppedCanvas().toBlob((blob) => {
        if (blob) {
          const url = URL?.createObjectURL(blob) || "";
          this.setState({ cropResult: url, uploadLogo: url });
          const file = new File(
            [blob],
            `${JSON.parse(sessionStorage?.userDetails)?.accountName + ".png"}`,
            { type: blob.type, lastModified: Date.now() },
          );
          this.setState({ files: file });
        }
      });
    }
  };

  handleOpen() {
    this.setState({ open: true });
  }

  handleClose() {
    this.setState({ open: false });
  }
  handleOpenPasswordDialog() {
    this.setState({ openPasswordDialog: true });
  }

  handleClosePasswordDialog() {
    this.setState({
      openPasswordDialog: false,
      form: { currentPassword: "", newPassword: "", confirmPassword: "" },
      showPassword: { current: false, new: false, confirm: false },
    });
  }

  handleChange = (e) => {
    const { name, value } = e.target;

    this.setState((prevState) => ({
      form: {
        ...prevState.form,
        [name]: value,
      },
      errors: {
        ...prevState.errors,
        [name]: "",
      },
    }));
  };

  togglePassword = (field) => {
    this.setState({
      showPassword: {
        ...this.state.showPassword,
        [field]: !this.state.showPassword[field],
      },
    });
  };

  handleSubmitPassword = () => {
    const { currentPassword, newPassword, confirmPassword } = this.state.form;

    this.setState({
      errors: {
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
        general: "",
      },
    });

    let errors = {};
    if (!currentPassword)
      errors.currentPassword = "Current password is required";
    if (!newPassword) errors.newPassword = "New password is required";
    if (!confirmPassword)
      errors.confirmPassword = "Confirm password is required";
    else if (newPassword !== confirmPassword)
      errors.confirmPassword = "Passwords do not match";

    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    const payload = {
      currentPassword: currentPassword,
      newPassword: newPassword,
    };

    this.setState({ loading: true });

    changedPassword(payload, (error, response) => {
      if (error) {
        this.setState({ loading: false });
        toast(
          error.response?.data?.message ||
            "Failed to change password. Try again.",
          {
            autoClose: 5000,
            type: toast.TYPE.ERROR,
            position: toast.POSITION.BOTTOM_CENTER,
          },
        );
        return;
      }

      if (response && response.data) {
        this.setState({ loading: false });

        if (response.data.success === 1) {
          toast(response.data.message || "Password changed successfully", {
            autoClose: 5000,
            type: toast.TYPE.SUCCESS,
            position: toast.POSITION.BOTTOM_CENTER,
          });
          setTimeout(() => {
            this.handleClosePasswordDialog();
            this.setState({
              form: {
                currentPassword: "",
                newPassword: "",
                confirmPassword: "",
              },
            });
          }, 1500);
        } else {
          toast(response.data.message || "Failed to change password.", {
            autoClose: 5000,
            type: toast.TYPE.ERROR,
            position: toast.POSITION.BOTTOM_CENTER,
          });
        }
      }
    });
  };

  handleCloseBusinessCreate() {
    this.setState({ createEnable: false });
  }

  handleLoader(value) {
    this.setState({ loaded: value, accountDisabled: false });
  }

  getcountryList() {
    getUserdetailsforsubscrption.getAllCountryList().then((res) => {
      this.setState({ countryListData: res.data.data });
      let countries = res?.data?.data;
      let countryCode = [];
      countries.filter(({ phonecode }) => countryCode.push(phonecode));
      const UniqueCountryCode = [...new Set(countryCode)];
      this.setState({ uniqueCountryCode: UniqueCountryCode.sort() });
    });
  }

  getStatesList(country) {
    getUserdetailsforsubscrption.getAllStateList(country).then((res) => {
      this.setState({ statesListData: res.data.data });
    });
  }

  componentWillReceiveProps(newProps) {
    const userDetails = window.sessionStorage.getItem("userDetails");
    const UserId = JSON.parse(userDetails).userId;
    const userInfoData = newProps.accountdetails.data;
    const nowValidated =
      (userInfoData && userInfoData.is_shopifyverified) || false;
    // When verify completes, close Shopify popup after 2s
    if (!this.state.isValidated && nowValidated) {
      this.scheduleCloseShopifyPopup();
    }
    sessionStorage.setItem(
      "isShopifyVerified",
      nowValidated ? "true" : "false",
    );
    this.setState({
      ...this.state,
      userId: userInfoData && userInfoData.userid,
      firstName: userInfoData && userInfoData.firstname,
      lastName: userInfoData && userInfoData.lastname,
      businessName: userInfoData && userInfoData.businessname,
      phoneNumber: userInfoData && userInfoData.phone,
      emailId: userInfoData && userInfoData.email,
      countryCode: userInfoData && userInfoData.countrycode,
      statename: userInfoData && userInfoData.accountstate,
      gender: userInfoData && userInfoData.gender,
      country: userInfoData && userInfoData.accountcountry,
      city: userInfoData && userInfoData.accountcity,
      zipCode: userInfoData && userInfoData.accountzip,
      zelleInfo: userInfoData && userInfoData.zelle,
      venmoInfo: userInfoData && userInfoData.venmo,
      addressLine1: userInfoData && userInfoData.accountaddressline1,
      addressLine2: userInfoData && userInfoData.accountaddressline2,
      bankName: userInfoData && userInfoData.bankname,
      accountNumber: userInfoData && userInfoData.accountnumber,
      accountName: userInfoData && userInfoData.accountname,
      achRouting: userInfoData && userInfoData.ach_routing,
      wireRouting: userInfoData && userInfoData.wire_routing,
      swiftCode: userInfoData && userInfoData.swiftcode,
      UploadPic: userInfoData && userInfoData.profilepic,
      uploadLogo: userInfoData && userInfoData.logo_url,
      tax_id: userInfoData && userInfoData.tax_id,
      is_business_enable: userInfoData && userInfoData.is_business_enable,
      shopname: (userInfoData && userInfoData.shop_name) || "",
      accessToken: (userInfoData && userInfoData.shop_accesstoken) || "",
      shopify_client_id: (userInfoData && userInfoData.shopify_client_id) || "",
      shopify_client_secret:
        (userInfoData && userInfoData.shopify_client_secret) || "",
      shopifyEmail: (userInfoData && userInfoData.shop_email) || "",
      shopifyUrl: (userInfoData && userInfoData.shop_url) || "",
      shopifyDomain: (userInfoData && userInfoData.shop_domain) || "",
      isValidated: (userInfoData && userInfoData.is_shopifyverified) || false,
      showValidationFields:
        (userInfoData && userInfoData.is_shopifyverified) || false,
      isQuickbookValidated:
        (userInfoData && userInfoData.qbo_isverified) || false,
      quickBookName:
        (this.state.companyDetails &&
          (this.state.companyDetails.CompanyName ||
            this.state.companyDetails.Name)) ||
        (userInfoData && userInfoData.CompanyName) ||
        "",
      quickBookEmail:
        (this.state.companyDetails &&
          (this.state.companyDetails.Email ||
            (this.state.companyDetails.PrimaryEmailAddr &&
              this.state.companyDetails.PrimaryEmailAddr.Address) ||
            this.state.companyDetails.Address)) ||
        (userInfoData && userInfoData.Address) ||
        "",
    });
    const isQboEnabled =
      window.sessionStorage.getItem("isQboEnabled") === "true";
    if (isQboEnabled) {
      try {
        addinvetrysearchdataa
          .getCompanyDetails()
          .then((res) => {
            const company = this.extractCompanyFromResponse(res);
            if (company) {
              const qbName =
                company.CompanyName || company.Name || this.state.quickBookName;
              const qbEmail =
                (company.Email && (company.Email.Address || company.Email)) ||
                (company.PrimaryEmailAddr &&
                  company.PrimaryEmailAddr.Address) ||
                company.Address ||
                this.state.quickBookEmail;
              this.setState({
                companyDetails: company,
                quickBookName: qbName,
                quickBookEmail: qbEmail,
              });
              try {
                window.sessionStorage.setItem(
                  "QBO_COMPANY_DETAILS",
                  JSON.stringify(company),
                );
              } catch (e) {}
            }
          })
          .catch((err) => console.debug("getCompanyDetails error", err));
      } catch (e) {
        console.debug("getCompanyDetails invocation failed", e);
      }
    }

    if (newProps.currentUser && !this.state.currentUser) {
      this.setState({ ...this.state, currentUser: newProps.currentUser });
      const payload = {
        userId: UserId,
        accountId: this.state.accountbusinessId,
      };
      this.props.getaccountdetails(payload);
    }
    this.getcountryList();
    if (userInfoData && userInfoData.accountcountry) {
      this.getStatesList(
        userInfoData && userInfoData.accountcountry
          ? userInfoData.accountcountry
          : null,
      );
    }
  }

  UploadPhoto = ({ target }) => {
    const userDetails = window.sessionStorage.getItem("userDetails");
    const UserId = JSON.parse(userDetails).userId;
    const imageFile = target.files[0];
    this.setState({
      onUploadPicErrorText: "",
      uploadLogo: false,
      isValid: true,
    });
    if (!imageFile) {
      this.setState({
        onUploadPicErrorText: "Please select image.",
        isValid: false,
      });
      return false;
    }
    if (!imageFile.name.match(/\.(jpg|JPG|png|PNG|jpeg|JPEG)$/)) {
      toast.error("Invalid file type! Allowed formats: JPG, JPEG, PNG,", {
        autoClose: 5000,
        position: toast.POSITION.BOTTOM_CENTER,
      });
      this.setState({
        onUploadPicErrorText:
          "Please select only jpg,png or jpeg format images",
        isValid: false,
      });
      return false;
    }
    var file = target.files[0];
    const previewUrl = URL.createObjectURL(file);
    this.setState({
      UploadPic1: previewUrl,
      file: file,
      isValid: true,
      UploadPic: previewUrl,
    });
    let fd = new FormData();
    fd.set("user_id", UserId);
    fd.set("image", file);
    addProfileImage(fd, (error, res) => {
      if (error) {
        console.error("Error uploading profile image:", error);
        toast.error("Failed to upload profile picture. Please try again.", {
          autoClose: 5000,
          position: toast.POSITION.BOTTOM_CENTER,
        });
        this.setState({
          UploadPic: this.props.accountdetails.data?.profilepic,
          UploadPic1: null,
        });
      } else {
        const payload = {
          userId: UserId,
          accountId: this.state.accountbusinessId,
        };
        this.props.updateProfilePic(res.data.data.profilepic);
        this.props.getaccountdetails(payload);
        toast.success("Profile picture updated successfully!", {
          autoClose: 3000,
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    });
  };

  onChangeOfFirstName = (event) => {
    let FirstNameVal = event.target.value;
    if (!FirstNameVal) {
      this.setState({
        ...this.state,
        onFirstNameErrorText: "Enter correct First Name",
        firstName: event.target.value,
        isValid: false,
      });
    } else {
      this.setState({
        ...this.state,
        onFirstNameErrorText: "",
        firstName: event.target.value,
        isValid: true,
      });
    }
  };

  onChangeOfBusinessName = (event) => {
    let BusinesstNameVal = event.target.value;
    if (!BusinesstNameVal) {
      this.setState({
        ...this.state,
        onBusinessNameErrorText: "Enter correct Business Name",
        businessName: event.target.value,
        isValid: false,
      });
    } else {
      this.setState({
        ...this.state,
        onBusinessNameErrorText: "",
        businessName: event.target.value,
        isValid: true,
      });
    }
  };

  onChangeOfLastName = (event) => {
    let LastNameVal = event.target.value;
    if (!LastNameVal) {
      this.setState({
        ...this.state,
        onLastNameErrorText: "Enter correct Last Name",
        lastName: event.target.value,
        isValid: false,
      });
    } else {
      this.setState({
        ...this.state,
        onLastNameErrorText: "",
        lastName: event.target.value,
        isValid: true,
      });
    }
  };

  onChangeOfGender = (event) => {
    let GenderVal = event.target.value;
    if (!GenderVal) {
      this.setState({
        ...this.state,
        onGenderErrorText: "Select Gender",
        gender: event.target.value,
        isValid: false,
      });
    } else {
      this.setState({
        ...this.state,
        onGenderErrorText: "",
        gender: event.target.value,
        isValid: true,
      });
    }
  };

  onChangeOfEmailId = (event) => {
    let emailIdVal = validator.isEmail(event.target.value);
    if (!emailIdVal) {
      this.setState({
        ...this.state,
        onEmailIdErrorText: "Enter correct Email Id",
        emailId: event.target.value,
        isValid: false,
      });
    } else {
      this.setState({
        ...this.state,
        onEmailIdErrorText: "",
        emailId: event.target.value,
        isValid: true,
      });
    }
  };

  // onChangeOfCountryCode = (event) => {
  //   const regex = "^(?:[+\d].*\d|\d)$";
  //   var sign = "+";
  //   let countryCodeVal =  event.target.value;
  //   let countryCode = countryCodeVal.match(regex);
  //  if (event.target.value >=1 && event.target.value <= 4) {
  // // let countryCodeVal = validator.isNumeric(event.target.value);
  //   if ( !countryCode) {
  //     this.setState({
  //       ...this.state,
  //       countryCodeError: "Enter minimum 3 characters for country code",
  //       isValid: false
  //     })
  //   }
  //   else {
  //     this.setState({
  //       ...this.state,
  //       countryCodeError: "",
  //       countryCode: countryCodeVal,
  //       isValid: true
  //     })
  //   }
  // }
  //   else {
  //     this.setState({
  //       ...this.state,
  //       countryCodeError: "",
  //       countryCode: this.state.sign + event.target.value,
  //       isValid: true
  //     })
  //   }
  // }
  // onChangeOfCountryCode = (event) => {
  //   let value = event.target.value;
  //   value = value.replace(/[^0-9]/g, "");
  //   let CountryCodeVal = validator.isNumeric(value);
  //   if (!CountryCodeVal && value !== "") {
  //     this.setState({
  //       ...this.state,
  //       onCountryCodeErrorText: "Enter correct Country Code",
  //       countryCode: value,
  //       isValid: false,
  //     });
  //   } else {
  //     this.setState({
  //       ...this.state,
  //       onCountryCodeErrorText: "",
  //       countryCode: value,
  //       isValid: true,
  //     });
  //   }
  // };
  onChangeOfCountryCode = (event) => {
    this.setState({
      ...this.state,
      onCountryCodeErrorText: "",
      countryCode: event.target.value,
      isValid: true,
    });
  };

  onChangeOfTaxId = (event) => {
    const taxIdVal = event.target.value.replace(/\D/g, "");
    if (taxIdVal.length >= 9) {
      const TaxId = `${taxIdVal.slice(0, 3)}-${taxIdVal.slice(3, 5)}-${taxIdVal.slice(5, 9)}`;
      this.setState({
        ...this.state,
        ontaxIdErrorText: "",
        tax_id: TaxId,
        isValid: true,
      });
    } else {
      this.setState({
        ...this.state,
        ontaxIdErrorText: "Enter correct Tax Id",
        tax_id: taxIdVal,
        isValid: false,
      });
    }
  };

  onChangeOfPhoneNumber = (event) => {
    const regex = "^\\d{10}$";
    let PhoneNumberVal = event.target.value;
    if (event.target.value >= 10) {
      let phonemuber = PhoneNumberVal.match(regex);
      if (!phonemuber) {
        this.setState({
          ...this.state,
          onPhoneNumberErrorText: "Enter correct Phone Number",
          phoneNumber: event.target.value,
          isValid: false,
        });
      } else {
        this.setState({
          ...this.state,
          onPhoneNumberErrorText: "",
          phoneNumber: event.target.value,
          isValid: true,
        });
      }
    } else {
      this.setState({
        ...this.state,
        onPhoneNumberErrorText: "",
        phoneNumber: event.target.value,
        isValid: true,
      });
    }
  };

  onChangeOfAddressLine1 = (event) => {
    let AddressLine1Val = event.target.value;
    if (!AddressLine1Val) {
      this.setState({
        ...this.state,
        onAddressLine1ErrorText: "Enter correct Address",
        addressLine1: event.target.value,
        isValid: false,
      });
    } else {
      this.setState({
        ...this.state,
        onAddressLine1ErrorText: "",
        addressLine1: event.target.value,
        isValid: true,
      });
    }
  };
  onChangeOfAddressLine2 = (event) => {
    let AddressLine2Val = event.target.value;
    if (!AddressLine2Val) {
      this.setState({
        ...this.state,
        onAddressLine2ErrorText: "Enter correct Address",
        addressLine2: event.target.value,
        isValid: false,
      });
    } else {
      this.setState({
        ...this.state,
        onAddressLine2ErrorText: "",
        addressLine2: event.target.value,
        isValid: true,
      });
    }
  };

  onChangeOfbankName = (event) => {
    let BankNameVal = event.target.value;
    if (!BankNameVal) {
      this.setState({
        ...this.state,
        onBankNameErrorText: "Enter correct BankName",
        bankName: event.target.value,
        isValid: false,
      });
    } else {
      this.setState({
        ...this.state,
        onBankNameErrorText: "",
        bankName: event.target.value,
        isValid: true,
      });
    }
  };

  onChangeOfaccountNumber = (event) => {
    let accountNumberVal = event.target.value;
    if (!accountNumberVal) {
      this.setState({
        ...this.state,
        onAccountNumberErrorText: "Enter correct Account Number",
        accountNumber: event.target.value,
        isValid: false,
      });
    } else {
      this.setState({
        ...this.state,
        onAccountNumberErrorText: "",
        accountNumber: event.target.value,
        isValid: true,
      });
    }
  };
  onChangeOfaccountName = (event) => {
    let accountNameVal = event.target.value;
    if (!accountNameVal) {
      this.setState({
        ...this.state,
        onAccountNameErrorText: "Enter correct Account Name",
        accountName: event.target.value,
        isValid: false,
      });
    } else {
      this.setState({
        ...this.state,
        onAccountNameErrorText: "",
        accountName: event.target.value,
        isValid: true,
      });
    }
  };

  onChangeOfachRouting = (event) => {
    let achRoutingVal = event.target.value;
    if (!achRoutingVal) {
      this.setState({
        ...this.state,
        onAchRoutingErrorText: "Enter correct ACH Routing",
        achRouting: event.target.value,
        isValid: false,
      });
    } else {
      this.setState({
        ...this.state,
        onAchRoutingErrorText: "",
        achRouting: event.target.value,
        isValid: true,
      });
    }
  };

  onChangeOfwireRouting = (event) => {
    let wireRoutingVal = event.target.value;
    if (!wireRoutingVal) {
      this.setState({
        ...this.state,
        onWireRoutingErrorText: "Enter correct Wire Routing",
        wireRouting: event.target.value,
        isValid: false,
      });
    } else {
      this.setState({
        ...this.state,
        onWireRoutingErrorText: "",
        wireRouting: event.target.value,
        isValid: true,
      });
    }
  };

  onChangeOfswiftCode = (event) => {
    let swiftCodeVal = event.target.value;
    if (!swiftCodeVal) {
      this.setState({
        ...this.state,
        onswiftCodeErrorText: "Enter correct Wire Routing",
        swiftCode: event.target.value,
        isValid: false,
      });
    } else {
      this.setState({
        ...this.state,
        onswiftCodeErrorText: "",
        swiftCode: event.target.value,
        isValid: true,
      });
    }
  };
  onChangeOfCountry(event) {
    this.setState({ country: event.target.value, statename: "" });
    getUserdetailsforsubscrption
      .getAllStateList(event.target.value)
      .then((res) => {
        this.setState({ statesListData: res.data.data });
      });
  }

  onChangeOfCity = (event) => {
    let CityVal = event.target.value;
    if (!CityVal) {
      this.setState({
        ...this.state,
        onCityErrorText: "Enter correct City",
        city: event.target.value,
        isValid: false,
      });
    } else {
      this.setState({
        ...this.state,
        onCityErrorText: "",
        city: event.target.value,
        isValid: true,
      });
    }
  };

  onChangeOfState = (event) => {
    let stateVal = event.target.value;
    if (stateVal === "") {
      this.setState({
        stateErrorText: "Enter State",
        isValid: false,
        statename: event.target.value,
      });
    } else {
      this.setState({
        stateErrorText: "",
        statename: event.target.value,
        isValid: true,
      });
    }
  };

  getstatebycountyId(countryID) {
    getUserdetailsforsubscrption.getAllStateList(countryID).then((res) => {
      this.setState({ statesListData: res.data.data });
    });
  }

  onChangeOfZipCode = (event) => {
    if (event.target.value !== "") {
      let zipcodeVal = validator.isNumeric(event.target.value);
      if (!zipcodeVal) {
        this.setState({
          ...this.state,
          onZipCodeErrorText: "Enter correct Zip Code",
          isValid: false,
        });
      } else {
        this.setState({
          ...this.state,
          onZipCodeErrorText: "",
          zipCode: event.target.value,
          isValid: true,
        });
      }
    } else {
      this.setState({
        ...this.state,
        onZipCodeErrorText: "",
        zipCode: event.target.value,
        isValid: true,
      });
    }
  };
  onChangeOfZelle = (event) => {
    let zelleVal = event.target.value;
    if (!zelleVal) {
      this.setState({
        ...this.state,
        zelleInfo: event.target.value,
        isValid: false,
      });
    } else {
      this.setState({
        ...this.state,
        onZelleErrorText: "",
        zelleInfo: event.target.value,
        isValid: true,
      });
    }
  };
  onChangeOfVenmo = (event) => {
    let venmoVal = event.target.value;
    if (!venmoVal) {
      this.setState({
        ...this.state,
        venmoInfo: event.target.value,
        isValid: false,
      });
    } else {
      this.setState({
        ...this.state,
        onVenmoErrorText: "",
        venmoInfo: event.target.value,
        isValid: true,
      });
    }
  };
  handleSubmit = () => {
    this.setState({
      isDisabled: false,
      editable: true,
      disbledntn: true,
      disbleeditbtn: false,
    });
  };
  handleSubmit1 = () => {
    this.setState({
      isDisabled1: false,
      editable1: true,
      disbledntn1: true,
      disbleeditbtn1: false,
    });
  };
  validateInput1() {
    let onBankNameErrorText = "";
    let onAccountNumberErrorText = "";
    let onAccountNameErrorText = "";
    let onAchRoutingErrorText = "";
    let onWireRoutingErrorText = "";
    let onSwiftCodeErrorText = "";
    let onUploadPicErrorText = "";
    let ontaxIdErrorText = "";
    let isValid = true;

    if (this.state.bankName === null) {
      onBankNameErrorText = "Enter Bank Name";
      isValid = false;
    }
    if (this.state.accountNumber === null) {
      onAccountNumberErrorText = "Enter Account Number";
      isValid = false;
    }
    if (this.state.accountName === null) {
      onAccountNameErrorText = "Enter Account Name";
      isValid = false;
    }
    if (this.state.achRouting === null) {
      onAchRoutingErrorText = "Enter ACH Routing";
      isValid = false;
    }
    if (this.state.wireRouting === null) {
      onWireRoutingErrorText = "Enter Wire Routing";
      isValid = false;
    }
    if (this.state.swiftCode === null) {
      onSwiftCodeErrorText = "Enter Swift Code";
      isValid = false;
    }
    this.setState({
      ...this.state,
      onBankNameErrorText,
      onAccountNumberErrorText,
      onAccountNameErrorText,
      onAchRoutingErrorText,
      onWireRoutingErrorText,
      onSwiftCodeErrorText,
      onUploadPicErrorText,
      ontaxIdErrorText,
    });
    return isValid;
  }

  validateInput() {
    let onAddressLine1ErrorText = "";
    let onAddressErrorText = "";
    let onBusinessNameErrorText = "";
    let onFirstNameErrorText = "";
    let onEmailIdErrorText = "";
    let onPhoneNumberErrorText = "";
    let onCountryErrorText = "";
    let onCityErrorText = "";
    let onZelleErrorText = "";
    let onVenmoErrorText = "";
    let onStateErrorText = "";
    let onZipCodeErrorText = "";
    let onLastNameErrorText = "";
    let onCountryCodeErrorText = "";
    let onUploadPicErrorText = "";
    let isValid = true;
    if (this.state.uploadLogo === "") {
      onUploadPicErrorText = "Please Upload Pic";
      isValid = false;
    }
    if (this.state.firstName === null) {
      onFirstNameErrorText = "Enter Correct Full Name";
      isValid = false;
    }
    if (this.state.phoneNumber === null || this.state.phoneNumber.length <= 9) {
      onPhoneNumberErrorText = "Enter Correct Phone Number";
      isValid = false;
    }
    if (this.state.lastName === null) {
      onLastNameErrorText = "Enter Last Name";
      isValid = false;
    }
    if (this.state.emailId === null) {
      onEmailIdErrorText = "Enter E-mail";
      isValid = false;
    }

    this.setState({
      ...this.state,
      onBusinessNameErrorText,
      onAddressLine1ErrorText,
      onFirstNameErrorText,
      onLastNameErrorText,
      onEmailIdErrorText,
      onPhoneNumberErrorText,
      onAddressErrorText,
      onCountryErrorText,
      onCityErrorText,
      onZelleErrorText,
      onVenmoErrorText,
      onStateErrorText,
      onZipCodeErrorText,
      onCountryCodeErrorText,
      onUploadPicErrorText,
    });
    return isValid;
  }
  updatepackage() {
    this.props.history.push("/dealersubscribtions");
  }
  submitForm1(event) {
    event.preventDefault();
    if (this.validateInput1()) {
      const userDetails = window.sessionStorage.getItem("userDetails")
        ? JSON.parse(window.sessionStorage.getItem("userDetails"))
        : null;
      let data1 = {
        businessname: this.state.businessName,
        accountnumber: this.state.accountNumber,
        accountname: this.state.accountName,
        ach_routing: this.state.achRouting,
        wire_routing: this.state.wireRouting,
        swiftcode: this.state.swiftCode,
        bankname: this.state.bankName,
        accountid: this.state.accountbusinessId
          ? this.state.accountbusinessId
          : userDetails?.accountId,
        tax_id: this.state.tax_id,
        state: this.state.statename,
        country: this.state.country,
        addressline1: this.state.addressLine1,
        addressline2: this.state.addressLine2,
        city: this.state.city,
        zip: this.state.zipCode,
        zelle: this.state.zelleInfo,
        venmo: this.state.venmoInfo,
      };
      if (!data1.addressline1) delete data1.addressline1;
      if (!data1.addressline2) delete data1.addressline2;
      if (!data1.city) delete data1.city;
      if (!data1.zipCode) delete data1.zipCode;
      let fd = new FormData();
      if (this.state.files) {
        fd.set("files", this.state.files);
      } else if (this.state.uploadLogo) {
        fd.set("logo_url", this.state.uploadLogo);
      }
      for (const key in data1) {
        fd.set(key, data1[key]);
      }
      this.setState({ isSavingBusiness1: true }, () => {
        getBusinessInfo(fd, (error, res) => {
          this.setState({
            isSavingBusiness1: false,
            disbledntn1: false,
            disbleeditbtn1: true,
            editable1: false,
            isDisabled1: true,
          });
        });
      });
    }
  }

  submitForm(event) {
    event.preventDefault();
    if (this.validateInput()) {
      let data = {
        first_name: this.state.firstName,
        last_name: this.state.lastName,
        business_name: this.state.businessName,
        gender: this.state.gender,
        country_code: this.state.countryCode,
        phone: this.state.phoneNumber,
        email: this.state.emailId,
      };
      let fd = new FormData();
      fd.set("files", this.state.files);
      for (const key in data) {
        fd.set(key, data[key]);
      }
      this.setState({ isSavingProfile: true }, () => {
        addProfileData(fd, (error, res) => {
          const existingUserDetails =
            JSON.parse(window.sessionStorage.getItem("userDetails")) || {};
          const updatedUserDetails = {
            ...existingUserDetails,
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            countryCode: this.state.countryCode,
            phone: this.state.phoneNumber,
            email: this.state.emailId,
          };
          window.sessionStorage.setItem(
            "userDetails",
            JSON.stringify(updatedUserDetails),
          );

          this.setState({
            isSavingProfile: false,
            disbledntn: false,
            disbleeditbtn: true,
            editable: false,
            isDisabled: true,
          });
        });
      });
    }
  }

  uploadLogo = (e) => {
    const target = e.target;
    const imageFile = target.files[0];
    this.setState({ onUploadLogoErrorText: "", isLogoValid: true });
    if (!imageFile?.name?.match(/\.(jpg|JPG|png|PNG|jpeg|JPEG)$/)) {
      toast.error("Invalid file type! Allowed formats: JPG, JPEG, PNG,", {
        autoClose: 5000,
        position: toast.POSITION.BOTTOM_CENTER,
      });
      this.setState({
        onUploadLogoErrorText:
          "Please select only jpg,png or jpeg format images",
        isLogoValid: false,
      });
      target.value = "";
      return false;
    } else {
      e.preventDefault();
      let files;
      if (e.dataTransfer) {
        files = e.dataTransfer.files;
      } else if (e.target) {
        files = e.target.files;
      }
      const reader = new FileReader();
      reader.onload = () => {
        this.setState({ src: reader.result, uploadLogo: reader.result });
      };
      reader.readAsDataURL(files[0]);
    }
  };

  handleMenuOpen = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };
  handleMenuClose = () => {
    this.setState({ anchorEl: null });
  };

  handleEdit = () => {
    this.handleMenuClose();
    this.setState({
      openShopifyDialog: true,
      accountId: this.state.accountId,
      tempShopName: this.state.shopname,
      tempClientId: this.state.shopify_client_id,
      tempSecretId: this.state.shopify_client_secret,
    });
  };
  handleClosePasswordDialog = () => {
    this.setState({
      openPasswordDialog: false,
      form: {
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      errors: {
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
        general: "",
      },
      loading: false,
    });
  };
  openShopifySetupPopup = (appUrl) => {
    // Clear config-page install flag so it cannot force /login in this popup
    try {
      sessionStorage.removeItem("shopifyInstallSource");
    } catch (e) {}

    // Compact size to fit Shopify store-picker card (avoid oversized blank space)
    const width = 500;
    const height = 720;
    // Open in the left corner
    const left = 16;
    const top = 16;
    const features = [
      `width=${width}`,
      `height=${height}`,
      `left=${left}`,
      `top=${top}`,
      "scrollbars=yes",
      "resizable=yes",
      "toolbar=no",
      "menubar=no",
      "location=yes",
      "status=no",
    ].join(",");

    // Close only if we already hold a live ref. Do NOT window.open("", name)
    // first — that blank open uses Chrome's one-popup-per-click and blocks the real one.
    try {
      if (this._shopifyPopup && !this._shopifyPopup.closed) {
        this._shopifyPopup.close();
      }
    } catch (e) {}

    // Keep reference so parent can close popup after verification
    this._shopifyPopup = window.open(appUrl, "shopifyAppSetup", features);
    try {
      if (this._shopifyPopup && !this._shopifyPopup.closed) {
        this._shopifyPopup.resizeTo(width, height);
        this._shopifyPopup.moveTo(left, top);
      }
    } catch (e) {}
  };

  handleSetup = () => {
    this.setState({ hideSetupBtn: true });
    const appUrl = constants.APP_URL;
    if (!this.state.appInstalledClicked && appUrl) {
      this.openShopifySetupPopup(appUrl);
      this.setState({ appInstalledClicked: true });
    }
  };
  handleAppSetup = () => {
    this.handleMenuClose();
    const appUrl = constants.APP_URL;
    if (appUrl) {
      this.openShopifySetupPopup(appUrl);
    } else {
      console.error("APP_URL is not defined in Constants");
    }
  };
  handleCloseShopifyDialog = () => {
    this.setState({
      openShopifyDialog: false,
      errors: {},
      tempShopName: "",
      tempClientId: "",
      tempSecretId: "",
      showClientId: false,
      showSecretId: false,
    });
  };

  handleInstructions = async () => {
    try {
      const response = await fetch(
        "https://impresari-images.s3.us-east-1.amazonaws.com/Shopify+Configuration.pdf",
      );
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "ShopifyConfiguration.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  handleValidateShopify = () => {
    this.setState({ isValidatingShopify: true });
    addinvetrysearchdataa
      .validateShopifyDetails()
      .then((response) => {
        this.setState({ isValidatingShopify: false });
        const authUrl = response?.data?.data?.authUrl;
        if (!authUrl) {
          showErrorToast("Auth URL not received");
          return;
        }
        try {
          if (!this._pubnubSubscribedShopify) {
            this._pubnubShopifyListener = { message: this.handleMessage };
            this.pubnub.addListener(this._pubnubShopifyListener);
            this.pubnub.subscribe({ channels: [`shopify-notify`] });
            this._pubnubSubscribedShopify = true;
          }
        } catch (e) {}
        this.openShopifySetupPopup(authUrl);
      })
      .catch((error) => {
        this.setState({ isValidatingShopify: false });
        showErrorToast("Validation failed");
      });
  };

  handleValidateQuickbook = () => {
    this.setState({ isValidatingQuickbook: true });
    addinvetrysearchdataa
      .saveQuickbookDetails()
      .then((response) => {
        this.setState({ isValidatingQuickbook: false });
        const authUrl = response?.data?.data?.authUrl;
        if (!authUrl) {
          showErrorToast("Auth URL not received");
          return;
        }
        try {
          if (!this._pubnubSubscribedQuickbook) {
            this._pubnubQuickbookListener = {
              message: this.handleMessageQuick,
            };
            this.pubnub.addListener(this._pubnubQuickbookListener);
            this.pubnub.subscribe({ channels: [`quickbook-notify`] });
            this._pubnubSubscribedQuickbook = true;
          }
        } catch (e) {}
        window.open(authUrl, "_blank", "noopener,noreferrer");
      })
      .catch((error) => {
        this.setState({ isValidatingQuickbook: false });
        showErrorToast("Validation failed");
      });
  };

  handleSaveShopify = () => {
    if (this.state.isSavingShopify) return;
    let errors = {};
    if (!this.state.tempShopName) {
      errors.shopname = "Shop Name is required";
    }
    if (!this.state.tempClientId) {
      errors.clientId = "Client ID is required";
    }
    if (!this.state.tempSecretId) {
      errors.secretId = "Client Secret is required";
    }
    this.setState({ errors });
    if (Object.keys(errors).length > 0) return;
    this.setState({ errors: {}, isSavingShopify: true });
    const payload = {
      accountId: this.state.accountbusinessId,
      shopname: this.state.tempShopName,
      shopify_client_id: this.state.tempClientId,
      shopify_client_secret: this.state.tempSecretId,
    };
    addinvetrysearchdataa.saveShopifyDetails(payload, (err, res) => {
      this.setState({ isSavingShopify: false });
      if (err || res?.success === 0) {
        const errorMsg =
          res?.message ||
          err?.response?.data?.message ||
          err?.message ||
          "Failed to Save Shopify details";
        showErrorToast(errorMsg);
        return;
      }
      this.setState({
        accountId: this.state.accountbusinessId,
        shopname: this.state.tempShopName,
        shopify_client_id: this.state.tempClientId,
        shopify_client_secret: this.state.tempSecretId,
        openShopifyDialog: false,
        showClientId: false,
        showSecretId: false,
      });
      toast.dismiss();
      showSuccessToast(res.message || "Shopify details saved successfully");
    });
  };

  renderProfileDetails() {
    const { open, openPasswordDialog, showPassword, form } = this.state;
    const userDetails = JSON.parse(
      window.sessionStorage.getItem("userDetails"),
    );
    const CountryList = this.props.countryListInfo.data;
    const userInfoData = this.props.userInfo.data;
    const activePackageData = this.props.activePackagesListInfo;
    let convertedState,
      convertedCountry = "";
    convertedState =
      this.state.statename &&
      this.state.statesListData &&
      this.state.statesListData.find(
        (item) => item.id === Number(this.state.statename),
      );
    convertedCountry =
      this.state.countryListData &&
      this.state.countryListData.find(
        (item) => item.id === Number(this.state.country),
      );
    const address =
      (this.state.addressLine1 ? this.state.addressLine1 + ", " : "") +
      (convertedState ? convertedState.name + ", " : "") +
      (convertedCountry ? convertedCountry.name + ", " : "") +
      (this.state.zipCode ? this.state.zipCode : "");
    let qboStored = null;
    try {
      const raw = window.sessionStorage.getItem("QBO_COMPANY_DETAILS");
      qboStored = raw ? JSON.parse(raw) : null;
    } catch (e) {
      qboStored = null;
    }
    const displayQuickBookName =
      this.state.quickBookName ||
      (qboStored &&
        ((qboStored.company_data &&
          (qboStored.company_data.CompanyName ||
            qboStored.company_data.Name)) ||
          qboStored.CompanyName ||
          qboStored.Name)) ||
      this.state.shopname ||
      "";
    const displayQuickBookEmail =
      this.state.quickBookEmail ||
      (qboStored &&
        ((qboStored.company_data &&
          qboStored.company_data.Email &&
          (qboStored.company_data.Email.Address ||
            qboStored.company_data.Email)) ||
          qboStored.Email ||
          (qboStored.PrimaryEmailAddr && qboStored.PrimaryEmailAddr.Address) ||
          qboStored.Address)) ||
      this.state.shopifyEmail ||
      "";

    return (
      <div
        style={{ height: "auto", margin: "20px 30px 30px 30px" }}
        className="space-bottom-30 someextrahight"
      >
        {this.state.loaded == false ? (
          <div class="d-spinner">
            <SpinnerRoundFilled
              size={51}
              thickness={125}
              speed={80}
              color="rgba(57, 107, 172, 1)"
              className="spp"
              enabled={this.state.loaded == false}
            />{" "}
          </div>
        ) : (
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={3}>
              <Paper>
                <div>
                  <div className="space-bottom-20">
                    <Typography
                      variant="h5"
                      align="center"
                      className="color-454545"
                    >
                      <b>My Profile</b>
                    </Typography>
                  </div>

                  <div className="profile-pic" style={{ position: "relative" }}>
                    <input
                      accept="image/*"
                      className="input-upload"
                      id="icon-button-file2"
                      type="file"
                      onChange={this.UploadPhoto}
                    />
                    <label htmlFor="icon-button-file2">
                      <div>
                        <EditIcon
                          onChange={this.UploadPhoto}
                          style={{
                            float: "right",
                            marginRight: "5px",
                            top: "-31px",
                            position: "absolute",
                            right: " 6px",
                            cursor: "pointer",
                          }}
                        />
                        {this.state.UploadPic ? (
                          <img
                            src={
                              this.state.UploadPic
                                ? this.state.UploadPic
                                : this.state.UploadPic1
                            }
                            alt="watchimage"
                            className="img-responsive"
                            style={{
                              width: "140px",
                              margin: "auto",
                              cursor: "pointer",
                            }}
                          />
                        ) : (
                          <img
                            src={profileimg}
                            alt="watchimage"
                            className="img-responsive"
                            style={{
                              width: "140px",
                              height: "140px",
                              backgroundSize: "cover",
                              borderRadius: "50%",
                              margin: "auto",
                              cursor: "pointer",
                            }}
                          />
                        )}
                      </div>
                    </label>
                    <FormHelperText className="error-o">
                      {this.state.profilePicErrorText}
                    </FormHelperText>
                  </div>
                  <div style={{ clear: "both" }}></div>
                  <div className="profile-Details space-bottom-20">
                    <Typography
                      variant="h5"
                      className="color-222426 text-transform"
                    >
                      <b>
                        {this.state.userId
                          ? this.state.firstName + " " + this.state.lastName
                          : "LOGIN"}
                      </b>
                    </Typography>
                  </div>
                  <Divider />
                  <div className="userdetails">
                    <ul>
                      <li>
                        <div
                          className="color-555555"
                          style={{ wordBreak: "break-word" }}
                        >
                          <Grid container spacing={2}>
                            <Grid item xs={1} md={1}>
                              <img src={Email} alt="" width="14px" />
                            </Grid>
                            <Grid item xs={11} md={9}>
                              &nbsp;&nbsp;{this.state.emailId}
                            </Grid>
                          </Grid>
                        </div>
                      </li>
                      <li>
                        <div
                          className="color-555555"
                          style={{ wordBreak: "break-word" }}
                        >
                          <Grid container spacing={2}>
                            <Grid item xs={1} md={1}>
                              <img src={phone} alt="" width="14px" />
                            </Grid>
                            <Grid item xs={10} md={9}>
                              &nbsp;&nbsp;{this.state.phoneNumber}
                            </Grid>
                            <Grid item xs={1} md={2}></Grid>
                          </Grid>
                        </div>
                      </li>
                      <li></li>
                    </ul>

                    {isActionAllowed(
                      this.state.accessData,
                      "delete_account",
                    ) && (
                      <Grid container justifyContent="center">
                        <Grid
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: "20px",
                          }}
                        >
                          <Button
                            onClick={this.handleOpen}
                            variant="contained"
                            size="small"
                            color="primary"
                            className=" float-right primary-bg color-white text-center1"
                          >
                            Delete Account
                          </Button>
                        </Grid>
                      </Grid>
                    )}

                    <RemoveAccountModal
                      open={this.state.open}
                      handleClose={this.handleClose}
                    />
                  </div>
                </div>

                <div>
                  <div className="space-bottom-20">
                    <div align="center">
                      <Button
                        className="primary-bg color-white"
                        largeButtonIcon
                        variant="contained"
                        color="primary"
                        startIcon={<LockResetIcon />}
                        onClick={this.handleOpenPasswordDialog}
                      >
                        Change Password
                      </Button>
                    </div>
                  </div>
                </div>
              </Paper>
            </Grid>
            <Grid item xs={12} sm={12} md={9}>
              <div style={{ marginBottom: "10px" }}>
                <Card
                  className="space-3"
                  style={{ borderTop: "1px solid rgba(0, 0, 0, 0.18)" }}
                >
                  <div className="space-padding-top-20 space-padding-bottom-20">
                    <Grid container spacing={1}>
                      <Grid item xs={6} sm={6} md={6}>
                        <div className="space-left-20">
                          <Typography
                            variant="h6"
                            component="p"
                            className="primary-text uppercase"
                          >
                            MY MEMBERSHIP
                          </Typography>
                        </div>
                      </Grid>
                      <Grid item xs={6} sm={6} md={6}></Grid>
                    </Grid>
                    <Grid container spacing={2}>
                      <Grid item xs={6} sm={6} md={6}>
                        <div style={{ marginLeft: "20px" }}>
                          <Typography variant="small">
                            <b>
                              {" "}
                              {activePackageData &&
                              activePackageData.membertiername
                                ? activePackageData.membertiername
                                : "You are using Free Plan"}
                            </b>
                          </Typography>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </Card>
              </div>
              <br />

              <Paper
                className="space-3"
                style={{
                  height: "auto",
                  borderTop: "1px solid rgba(0, 0, 0, 0.18)",
                }}
              >
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.submitForm1(e);
                  }}
                >
                  <div className=" space-left-20">
                    <Typography
                      variant="h6"
                      component="p"
                      className="primary-text uppercase"
                    >
                      BUSINESS INFORMATION
                    </Typography>
                    <Button
                      variant="contained"
                      color="primary"
                      className="float-right primary-bg color-white text-center1 form-width-20"
                      style={{ bottom: "30px" }}
                      onClick={this.handleSubmit1}
                      disabled={this.state.editable1}
                    >
                      EDIT
                    </Button>
                    {this.state.accountDisabled &&
                      [3, 6].includes(userDetails?.roleId) && (
                        <Button
                          variant="contained"
                          color="primary"
                          startIcon={<PersonAddIcon />}
                          disabled={
                            userDetails?.is_business_enable ? false : true
                          }
                          className={
                            userDetails?.is_business_enable
                              ? " float-right primary-bg color-white text-center1 form-width-20"
                              : " float-right text-center1 form-width-20"
                          }
                          style={{ bottom: "30px", marginRight: "20px" }}
                          onClick={() => this.setState({ createEnable: true })}
                        >
                          Add Business
                        </Button>
                      )}
                  </div>
                  <div className="space-2">
                    <Grid container spacing={1}>
                      {!this.state.isDisabled1 && (
                        <Grid
                          item
                          xs={9}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "30px",
                            paddingBottom: "15px",
                          }}
                        >
                          <input
                            accept="image/*"
                            className="input-upload"
                            id="image"
                            name="files"
                            type="file"
                            onChange={(e) => this.uploadLogo(e)}
                          />
                          <label htmlFor="image">
                            <div
                              className="primary-border bg-color-F5F5F5"
                              style={{
                                boxShadow: "0 10px 6px -6px #777",
                                width: "200px",
                                marginBottom: "30px",
                              }}
                            >
                              <div
                                className="space-5 text-center1"
                                style={{ width: "100%" }}
                              >
                                <div className="text-center1">
                                  <Typography variant="body2">
                                    Upload Company Logo
                                  </Typography>
                                </div>
                              </div>
                            </div>
                          </label>
                          <Cropper
                            ref={this.cropperRef}
                            src={this.state.src}
                            style={{ height: 300, width: 300 }}
                            aspectRatio={1}
                            guides={false}
                            crop={this.cropImage}
                            background={false}
                            responsive={true}
                          />
                          <button
                            onClick={this.cropImage}
                            style={{ display: "none" }}
                          >
                            Crop Image
                          </button>
                          {!this.state.isLogoValid && (
                            <FormHelperText className="error-o">
                              {this.state.onUploadLogoErrorText}
                            </FormHelperText>
                          )}
                        </Grid>
                      )}
                      <Grid
                        item
                        xs={9}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          textAlign: "center",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <div
                          className="form-group multi-preview"
                          style={{ display: "block" }}
                        >
                          {this.state.isDisabled1 && (
                            <div
                              className="space-marign-bottom-10"
                              style={{ textAlign: "center" }}
                            >
                              <label className="myprofile-font">
                                Company Logo
                              </label>
                            </div>
                          )}
                          {this.state.uploadLogo && (
                            <img
                              src={
                                this.state.uploadLogo?.includes('"')
                                  ? this.state.uploadLogo.replaceAll('"', "")
                                  : this.state.uploadLogo
                              }
                              alt="Business logo"
                              width="200px"
                            />
                          )}
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={12} md={6}>
                        <FormControl className="form-width-100 margin-t-b-20 margin-p-b-20">
                          <label className="myprofile-font">
                            Business Name:
                          </label>
                          <TextField
                            required
                            id="standard-password-input"
                            disabled={this.state.isDisabled}
                            value={this.state.businessName}
                            onChange={this.onChangeOfBusinessName}
                            type="text"
                            className="registerSpace"
                            aria-describedby="component-error-text"
                          />
                          <FormHelperText className="error-o">
                            {this.state.onBusinessNameErrorText}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12} md={6}>
                        <FormControl className="form-width-100 margin-t-b-20 margin-p-b-20">
                          <label className="myprofile-font">Bank Name:</label>
                          <TextField
                            id="standard-password-input"
                            required
                            disabled={this.state.isDisabled1}
                            value={this.state.bankName}
                            onChange={this.onChangeOfbankName}
                            type="text"
                            className="registerSpace"
                            aria-describedby="component-error-text"
                          />
                          <FormHelperText className="error-o">
                            {this.state.onBankNameErrorText}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12} md={6}>
                        <FormControl className="form-width-100 margin-t-b-20 margin-p-b-20">
                          <label className="myprofile-font">
                            Account Name:
                          </label>
                          <TextField
                            id="standard-password-input"
                            required
                            disabled={this.state.isDisabled1}
                            value={this.state.accountName}
                            onChange={this.onChangeOfaccountName}
                            type="text"
                            className="registerSpace"
                            aria-describedby="component-error-text"
                          />
                          <FormHelperText className="error-o">
                            {this.state.onAccountNameErrorText}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12} md={6}>
                        <FormControl className="form-width-100 margin-t-b-20 margin-p-b-20">
                          <label className="myprofile-font">
                            Account Number:
                          </label>
                          <TextField
                            id="standard-password-input"
                            required
                            disabled={this.state.isDisabled1}
                            value={this.state.accountNumber}
                            onChange={this.onChangeOfaccountNumber}
                            type="text"
                            className="registerSpace"
                            aria-describedby="component-error-text"
                          />
                          <FormHelperText className="error-o">
                            {this.state.onAccountNumberErrorText}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12} md={6}>
                        <FormControl className="form-width-100 margin-t-b-20 margin-p-b-20">
                          <label className="myprofile-font">ACH Routing:</label>
                          <TextField
                            id="standard-password-input"
                            required
                            disabled={this.state.isDisabled1}
                            value={this.state.achRouting}
                            onChange={this.onChangeOfachRouting}
                            type="text"
                            className="registerSpace"
                            aria-describedby="component-error-text"
                          />
                          <FormHelperText className="error-o">
                            {this.state.onAchRoutingErrorText}
                          </FormHelperText>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={12} md={6}>
                        <FormControl className="form-width-100 margin-t-b-20 margin-p-b-20">
                          <label className="myprofile-font">
                            Wire Routing:
                          </label>
                          <TextField
                            id="standard-password-input"
                            required
                            disabled={this.state.isDisabled1}
                            value={this.state.wireRouting}
                            onChange={this.onChangeOfwireRouting}
                            type="text"
                            className="registerSpace"
                            aria-describedby="component-error-text"
                          />
                          <FormHelperText className="error-o">
                            {this.state.onWireRoutingErrorText}
                          </FormHelperText>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={12} md={6}>
                        <FormControl className="form-width-100 margin-t-b-20 margin-p-b-20">
                          <label className="myprofile-font">Swift Code:</label>
                          <TextField
                            id="standard-password-input"
                            required
                            disabled={this.state.isDisabled1}
                            value={this.state.swiftCode}
                            onChange={this.onChangeOfswiftCode}
                            type="text"
                            className="registerSpace"
                            aria-describedby="component-error-text"
                          />
                          <FormHelperText className="error-o">
                            {this.state.onSwiftCodeErrorText}
                          </FormHelperText>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={12} md={6}>
                        <FormControl className="form-width-100 margin-t-b-20 margin-p-b-20">
                          <label className="myprofile-font">Country:</label>
                          <Select
                            style={{ marginTop: 0 }}
                            value={this.state.country}
                            disabled={this.state.isDisabled1}
                            onChange={this.onChangeOfCountry}
                          >
                            {this.state.countryListData &&
                              this.state.countryListData.map((Country) => (
                                <MenuItem value={Country.id}>
                                  {Country.name}
                                </MenuItem>
                              ))}
                          </Select>
                          <FormHelperText className="error-o">
                            {this.state.onCountryErrorText}
                          </FormHelperText>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={12} md={6}>
                        <FormControl className="form-width-100 margin-t-b-20 margin-p-b-20">
                          <label className="myprofile-font">
                            Address Line1:
                          </label>
                          <TextField
                            id="standard-password-input"
                            disabled={this.state.isDisabled1}
                            value={this.state.addressLine1}
                            onChange={this.onChangeOfAddressLine1}
                            type="text"
                            className="registerSpace"
                            aria-describedby="component-error-text"
                          />
                          <FormHelperText className="error-o">
                            {this.state.onAddressLine1ErrorText}
                          </FormHelperText>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={12} md={6}>
                        <FormControl className="form-width-100 margin-t-b-20 margin-p-b-20">
                          <label className="myprofile-font">
                            Address Line2:
                          </label>
                          <TextField
                            id="standard-password-input"
                            disabled={this.state.isDisabled1}
                            value={this.state.addressLine2}
                            onChange={this.onChangeOfAddressLine2}
                            type="text"
                            className="registerSpace"
                            aria-describedby="component-error-text"
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={12} md={6}>
                        <FormControl className="form-width-100 margin-t-b-20 margin-p-b-20">
                          <label className="myprofile-font">City:</label>
                          <TextField
                            id="standard-password-input"
                            disabled={this.state.isDisabled1}
                            value={this.state.city}
                            onChange={this.onChangeOfCity}
                            type="text"
                            className="registerSpace"
                            aria-describedby="component-error-text"
                          />
                          <FormHelperText className="error-o">
                            {this.state.onCityErrorText}
                          </FormHelperText>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={12} md={6}>
                        <FormControl className="form-width-100 margin-t-b-20 margin-p-b-20">
                          <label className="myprofile-font">State:</label>
                          <Select
                            style={{ marginTop: 0 }}
                            value={
                              this.state.statename
                                ? Number(this.state.statename)
                                : ""
                            }
                            disabled={this.state.isDisabled1}
                            onChange={this.onChangeOfState}
                          >
                            {this.state.statesListData &&
                              this.state.statesListData.map((item) => (
                                <MenuItem value={item.id}>{item.name}</MenuItem>
                              ))}
                          </Select>
                          <FormHelperText className="error-o">
                            {this.state.onStateErrorText}
                          </FormHelperText>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={12} md={6}>
                        <FormControl className="form-width-100 margin-t-b-20 margin-p-b-20">
                          <label className="myprofile-font">Zip Code:</label>
                          <TextField
                            id="standard-password-input"
                            disabled={this.state.isDisabled1}
                            value={this.state.zipCode}
                            onChange={this.onChangeOfZipCode}
                            inputProps={{ maxLength: 6 }}
                            type="text"
                            className="registerSpace"
                            aria-describedby="component-error-text"
                          />
                          <FormHelperText className="error-o">
                            {this.state.onZipCodeErrorText}
                          </FormHelperText>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={12} md={6}></Grid>

                      <Grid item xs={12} sm={12} md={6}>
                        <FormControl className="form-width-100 margin-t-b-20 margin-p-b-20">
                          <label className="myprofile-font">
                            Zelle Information:
                          </label>
                          <TextField
                            id="standard-password-input"
                            disabled={this.state.isDisabled1}
                            value={this.state.zelleInfo}
                            onChange={this.onChangeOfZelle}
                            type="text"
                            className="registerSpace"
                            aria-describedby="component-error-text"
                          />
                          <FormHelperText className="error-o">
                            {this.state.onZelleErrorText}
                          </FormHelperText>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={12} md={6}>
                        <FormControl className="form-width-100 margin-t-b-20 margin-p-b-20">
                          <label className="myprofile-font">
                            Venmo Information:
                          </label>
                          <TextField
                            id="standard-password-input"
                            disabled={this.state.isDisabled1}
                            value={this.state.venmoInfo}
                            onChange={this.onChangeOfVenmo}
                            type="text"
                            className="registerSpace"
                            aria-describedby="component-error-text"
                          />
                          <FormHelperText className="error-o">
                            {this.state.onVenmoErrorText}
                          </FormHelperText>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={12} md={6}>
                        {this.state.disbledntn1 ? (
                          <Button
                            type="submit"
                            className="SubmitColor space-marign-20"
                            disabled={this.state.isSavingBusiness1}
                            onClick={(e) => this.submitForm1(e)}
                            fullWidth={false}
                          >
                            {this.state.isSavingBusiness1 ? (
                              <>
                                <CircularProgress
                                  size={18}
                                  color="inherit"
                                  style={{ marginRight: 8 }}
                                />
                                Update
                              </>
                            ) : (
                              "Update"
                            )}
                          </Button>
                        ) : (
                          ""
                        )}
                      </Grid>
                    </Grid>
                  </div>
                </form>
              </Paper>
              <br />
              <Paper
                className="space-3"
                style={{
                  height: "auto",
                  borderTop: "1px solid rgba(0, 0, 0, 0.18)",
                }}
              >
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.submitForm(e);
                  }}
                >
                  <div className=" space-left-20">
                    <Typography
                      variant="h6"
                      component="p"
                      className="primary-text uppercase"
                    >
                      PROFILE INFORMATION
                    </Typography>
                    {this.state.disbleeditbtn ? (
                      <Button
                        variant="contained"
                        color="primary"
                        className=" float-right primary-bg color-white text-center1 form-width-20"
                        style={{ bottom: "30px" }}
                        onClick={this.handleSubmit}
                      >
                        EDIT
                      </Button>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="space-2">
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={12} md={6}>
                        <FormControl className="form-width-100 margin-b-20 margin-p-b-20">
                          <label className="myprofile-font">First Name:</label>
                          <TextField
                            required
                            id="standard-password-input"
                            disabled={this.state.isDisabled}
                            value={this.state.firstName}
                            onChange={this.onChangeOfFirstName}
                            type="text"
                            className="registerSpace"
                          />
                          <FormHelperText className="error-o">
                            {this.state.onFirstNameErrorText}
                          </FormHelperText>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={12} md={6}>
                        <FormControl className="form-width-100 margin-b-10 margin-p-b-20">
                          <label className="myprofile-font">Last Name:</label>
                          <TextField
                            required
                            id="standard-password-input"
                            disabled={this.state.isDisabled}
                            value={this.state.lastName}
                            onChange={this.onChangeOfLastName}
                            type="text"
                            className="registerSpace"
                            aria-describedby="component-error-text"
                          />
                          <FormHelperText className="error-o">
                            {this.state.onLastNameErrorText}
                          </FormHelperText>
                        </FormControl>
                      </Grid>

                      {/* <Grid item xs={12} sm={12} md={6}>
                        <FormControl className="form-width-100 margin-t-b-20 margin-p-b-20">
                          <label className="myprofile-font">
                            Country Code:
                          </label>
                          <TextField
                            required
                            id="standard-password-input"
                            disabled={this.state.isDisabled}
                            value={this.state.countryCode}
                            onChange={this.onChangeOfCountryCode}
                            inputProps={{ maxLength: 4 }}
                            type="text"
                            className="registerSpace"
                            aria-describedby="component-error-text"
                          />
                          <FormHelperText className="error-o">
                            {this.state.onCountryCodeErrorText}
                          </FormHelperText>
                        </FormControl>
                      </Grid> */}

                      <Grid item xs={12} sm={12} md={6}>
                        <FormControl className="form-width-100 margin-t-b-20 margin-p-b-20">
                          <label className="myprofile-font">
                            Mobile Number:
                          </label>

                          <Grid
                            container
                            alignItems="flex-end"
                            spacing={1}
                          >
                            {/* Country Code */}
                            <Grid item style={{ width: "85px" }}>
                              <Select
                                id="demo-simple-select-outlined"
                                value={this.state.countryCode || "+1"}
                                disabled={this.state.isDisabled}
                                onChange={this.onChangeOfCountryCode}
                                style={{
                                  width: "100%",
                                  marginTop: "0px",
                                }}
                              >
                                {this.state.uniqueCountryCode &&
                                  this.state.uniqueCountryCode.map((country) => (
                                    <MenuItem key={country} value={country}>
                                      {country}
                                    </MenuItem>
                                  ))}
                              </Select>
                            </Grid>
                          <Grid item xs>
                          <TextField
                            required
                            id="standard-password-input"
                            disabled={this.state.isDisabled}
                            value={this.state.phoneNumber}
                            onChange={this.onChangeOfPhoneNumber}
                            inputProps={{ maxLength: 10 }}
                            type="text"
                            className="registerSpace"
                            aria-describedby="component-error-text"
                            fullWidth
                          />
                          </Grid>
                          </Grid>
                          <FormHelperText className="error-o">
                            {this.state.onPhoneNumberErrorText}
                          </FormHelperText>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={12} md={6}>
                        <FormControl className="form-width-100 margin-t-b-20 margin-p-b-20">
                          <label className="myprofile-font">Email:</label>
                          <TextField
                            required
                            id="standard-password-input"
                            disabled={true}
                            value={this.state.emailId}
                            onChange={this.onChangeOfEmailId}
                            type="text"
                            className="registerSpace"
                            aria-describedby="component-error-text"
                          />
                          <FormHelperText className="error-o">
                            {this.state.onEmailIdErrorText}
                          </FormHelperText>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "10px",
                      }}>
                        {this.state.disbledntn && (
                          <Button
                            type="submit"
                            className="primary-bg color-white"
                            variant="contained"
                            color="primary"
                            disabled={this.state.isSavingProfile}
                            onClick={(e) => this.submitForm(e)}
                          >
                            {this.state.isSavingProfile ? (
                              <>
                                <CircularProgress size={18} color="inherit" />
                                Update
                              </>
                            ) : (
                              "Update"
                            )}
                          </Button>
                        )}
                      </Grid>
                    </Grid>
                    <div></div>
                  </div>
                </form>
              </Paper>
              <br />

              {this.state.isShopifyEnabled && (
                <Paper
                  id="shopify-information"
                  className="space-3"
                  style={{
                    height: "auto",
                    borderTop: "1px solid rgba(0, 0, 0, 0.18)",
                    scrollMarginTop: 160,
                  }}
                >
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      this.submitForm(e);
                    }}
                  >
                    <div
                      className=" space-left-20"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "-20px"
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center" ,}}>
                        <Typography
                          variant="h6"
                          component="p"
                          className="primary-text uppercase"
                        >
                          SHOPIFY INFORMATION
                        </Typography>
                        {!this.state.isValidated && this.state.shopname && (
                          <Chip
                            label="Not Verified"
                            size="small"
                            className="void-status"
                            style={{ marginLeft: "8px"}}
                          />
                        )}
                        {this.state.isValidated && (
                          <>
                            <VerifiedIcon
                              style={{ color: "green", marginLeft: "8px" }}
                            />
                            <Chip
                              label="Verified"
                              size="small"
                              style={{
                                color: "green",
                                backgroundColor: "white",
                              }}
                            />
                          </>
                        )}
                      </div>
                      <div>
                        <IconButton
                          aria-label="more"
                          aria-controls="shopify-menu"
                          aria-haspopup="true"
                          onClick={this.handleMenuOpen}
                        >
                          <MoreVertIcon />
                        </IconButton>
                        <Menu
                          id="shopify-menu"
                          anchorEl={this.state.anchorEl}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                          PaperProps={{
                            elevation: 4,
                            style: {
                              borderRadius: 8,
                              minWidth: 160,
                              padding: "4px 0",
                            },
                          }}
                          keepMounted
                          open={Boolean(this.state.anchorEl)}
                          onClose={this.handleMenuClose}
                        >
                          {this.state.isShopifyEnabled &&
                            !this.state.isValidated &&
                            this.state.shopname && (
                              <MenuItem onClick={this.handleEdit}>
                                <EditOutlinedIcon
                                  fontSize="small"
                                  sx={{ mr: 1 }}
                                />
                                Edit
                              </MenuItem>
                            )}
                          <MenuItem
                            component="a"
                            href="https://impresari-images.s3.us-east-1.amazonaws.com/Shopify+Configuration.pdf"
                            target="_blank"
                            disabled={
                              !(
                                userDetails?.roleId === 3 ||
                                userDetails?.roleId === 6
                              )
                            }
                          >
                            <DownloadOutlinedIcon
                              fontSize="small"
                              style={{ marginRight: 8 }}
                            />
                            Instructions
                          </MenuItem>
                          <MenuItem onClick={this.handleAppSetup}>
                            <BeenhereIcon fontSize="small" sx={{ mr: 1 }} />
                            App Setup
                          </MenuItem>
                        </Menu>
                      </div>
                    </div>

                    <Grid container justifyContent="center" alignItems="center">
                      {!this.state.isValidated &&
                        (!this.state.shopname ||
                          this.state.shopname === "" ||
                          this.state.shopname === null) &&
                        !this.state.hideSetupBtn && (
                          <Button
                            size="small"
                            clickable
                            onClick={this.handleSetup}
                            className="void-status pulse-chip"
                            style={{ marginLeft: "30px", height: "38px" }}
                          >
                            Complete App Setup
                          </Button>
                        )}
                      &emsp;
                      {this.state.isValidated ? null : !this.state.shopname ? (
                        <Button
                          variant="contained"
                          color="primary"
                          className="float-right primary-bg color-white text-center1 form-width-20"
                          style={{ margin: "50px 0px" }}
                          startIcon={<LocalMallOutlinedIcon />}
                          onClick={() =>
                            this.setState({ openSetupModal: true })
                          }
                        >
                          Configure Shopify
                        </Button>
                      ) : null}
                    </Grid>

                    <div className="space-2">
                      {this.state.isValidated &&
                        this.state.needsShopifyApproval && (
                          <div
                            style={{
                              display: "none",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: 16,
                              flexWrap: "wrap",
                              background: "#FFF8E1",
                              border: "1px solid #FFE082",
                              borderRadius: 8,
                              padding: "12px 16px",
                              marginBottom: 24,
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 10,
                                flex: 1,
                                minWidth: 220,
                              }}
                            >
                              <WarningAmberIcon
                                style={{ color: "#F9A825", fontSize: 22 }}
                              />
                              <Typography
                                style={{
                                  color: "#8D6E63",
                                  fontSize: 14,
                                  fontWeight: 500,
                                }}
                              >
                                Complete setup in Shopify to activate billing.
                              </Typography>
                            </div>
                            <Button
                              variant="contained"
                              color="primary"
                              className="primary-bg color-white"
                              size="small"
                              onClick={this.handleGoToBilling}
                              style={{
                                fontWeight: 700,
                                textTransform: "uppercase",
                                whiteSpace: "nowrap",
                                padding: "6px 16px",
                              }}
                            >
                              Complete Billing 
                            </Button>
                          </div>
                        )}
                      <Grid container spacing={1}>
                        {this.state.shopname && (
                          <Grid item xs={12} md={6}>
                            <FormControl className="form-width-100 margin-b-30 margin-p-b-20">
                              <label className="myprofile-font">
                                Shop Name:
                              </label>
                              <TextField
                                disabled
                                value={this.state.shopname}
                                fullWidth
                                className="registerSpace"
                              />
                            </FormControl>
                          </Grid>
                        )}
                        {this.state.isValidated && (
                          <>
                            <Grid item xs={12} md={6}>
                              <FormControl fullWidth>
                                <label className="myprofile-font">
                                  Shopify Email:
                                </label>
                                <TextField
                                  disabled
                                  fullWidth
                                  value={this.state.shopifyEmail}
                                />
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <FormControl className="form-width-100 margin-b-30 margin-p-b-20">
                                <label className="myprofile-font">
                                  Shopify URL:
                                </label>
                                <TextField
                                  disabled
                                  fullWidth
                                  value={this.state.shopifyUrl}
                                  className="registerSpace"
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <Tooltip title="Copy URL">
                                          <IconButton
                                            size="small"
                                            onClick={() => {
                                              navigator.clipboard.writeText(
                                                this.state.shopifyUrl,
                                              );
                                              showSuccessToast(
                                                "Copied to clipboard",
                                              );
                                            }}
                                          >
                                            <ContentCopyIcon fontSize="small" />
                                          </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Open URL">
                                          <IconButton
                                            size="small"
                                            onClick={() =>
                                              window.open(
                                                this.state.shopifyUrl,
                                                "_blank",
                                              )
                                            }
                                          >
                                            <OpenInNewIcon fontSize="small" />
                                          </IconButton>
                                        </Tooltip>
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <FormControl className="form-width-100 margin-b-30 margin-p-b-20">
                                <label className="myprofile-font">
                                  Shopify Domain:
                                </label>
                                <TextField
                                  disabled
                                  fullWidth
                                  value={this.state.shopifyDomain}
                                  className="registerSpace"
                                />
                              </FormControl>
                            </Grid>
                          </>
                        )}
                        {this.state.shopname && !this.state.isValidated && (
                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              marginTop: "30px",
                            }}
                          >
                            <Button
                              className="primary-bg color-white"
                              variant="contained"
                              color="primary"
                              onClick={this.handleValidateShopify}
                            >
                              Validate
                            </Button>
                          </div>
                        )}
                      </Grid>
                    </div>
                  </form>
                </Paper>
              )}
              <br />

             {this.state.isEbayEnabled === true && (
                <>
                  <EbaySettings />
                  <br />
                </>
              )}

              {this.state.isQboEnabled && (
                <Paper
                  className="space-3"
                  style={{
                    height: "auto",
                    borderTop: "1px solid rgba(0, 0, 0, 0.18)",
                  }}
                >
                  <div
                    className=" space-left-20"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        variant="h6"
                        component="p"
                        className="primary-text uppercase"
                      >
                        QuickBook INFORMATION
                      </Typography>
                      {!this.state.isQuickbookValidated && (
                        <Chip
                          label="Not Verified"
                          size="small"
                          className="void-status"
                          style={{ marginLeft: "8px" }}
                        />
                      )}
                      {this.state.isQuickbookValidated && (
                        <>
                          <VerifiedIcon
                            style={{ color: "green", marginLeft: "8px" }}
                          />
                          <Chip
                            label="Verified"
                            size="small"
                            style={{ color: "green", backgroundColor: "white" }}
                          />
                        </>
                      )}
                    </div>
                  </div>
                  <div className="space-2">
                    {this.state.isQuickbookValidated && (
                      <Grid container spacing={1}>
                        <Grid item xs={12} md={6}>
                          <FormControl fullWidth>
                            <label className="myprofile-font">Shop Name:</label>
                            <TextField
                              disabled
                              fullWidth
                              value={displayQuickBookName}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <FormControl fullWidth>
                            <label className="myprofile-font">
                              QuickBook Email:
                            </label>
                            <TextField
                              disabled
                              fullWidth
                              value={displayQuickBookEmail}
                            />
                          </FormControl>
                        </Grid>
                      </Grid>
                    )}
                    {!this.state.isQuickbookValidated && (
                      <Button
                        className="primary-bg color-white"
                        variant="contained"
                        color="primary"
                        style={{ marginLeft: "300px" }}
                        startIcon={<LocalMallOutlinedIcon />}
                        onClick={this.handleValidateQuickbook}
                      >
                        Configure QuickBook
                      </Button>
                    )}
                  </div>
                </Paper>
              )}
            </Grid>

            {this.state.createEnable ? (
              <BusinessCreatemodel
                open={this.state.createEnable}
                handleloader={this.handleLoader}
                handleClose={this.handleCloseBusinessCreate}
                statedata={this.state.statesListData}
                countrydata={this.state.countryListData}
              />
            ) : (
              ""
            )}
          </Grid>
        )}

        <Dialog
          open={this.state.openShopifyDialog}
          onClose={this.handleCloseShopifyDialog}
          fullWidth
          maxWidth="lg"
          PaperProps={{ style: { width: "650px" } }}
        >
          <DialogTitle className="primary-text uppercase">
            Configure Shopify
            <IconButton
              style={{
                float: "right",
                marginTop: "-10px",
                marginRight: "-15px",
              }}
              onClick={this.handleCloseShopifyDialog}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent style={{ padding: "20px 25px" }}>
            <form autoComplete="off">
              <input
                type="text"
                name="prevent_autofill_user"
                autoComplete="username"
                tabIndex={-1}
                aria-hidden="true"
                style={{
                  position: "absolute",
                  opacity: 0,
                  height: 0,
                  width: 0,
                  pointerEvents: "none",
                }}
              />
              <input
                type="password"
                name="prevent_autofill_pass"
                autoComplete="current-password"
                tabIndex={-1}
                aria-hidden="true"
                style={{
                  position: "absolute",
                  opacity: 0,
                  height: 0,
                  width: 0,
                  pointerEvents: "none",
                }}
              />
            <TextField
              margin="dense"
              label="Shop Name"
              name="shopify_shop_name"
              fullWidth
              boxShadow="none"
              style={{ margin: "15px 0px" }}
              autoComplete="off"
              inputProps={{
                autoComplete: "off",
                autoCorrect: "off",
                autoCapitalize: "off",
                spellCheck: "false",
              }}
              value={this.state.tempShopName}
              onChange={(e) => this.setState({ tempShopName: e.target.value })}
            />
            {this.state.errors?.shopname && (
              <span
                style={{
                  color: "red",
                  fontSize: "13px",
                  marginBottom: "4px",
                  display: "block",
                }}
              >
                {this.state.errors.shopname}
              </span>
            )}
            <TextField
              margin="dense"
              label="Client ID"
              name="shopify_client_id"
              fullWidth
              boxShadow="none"
              style={{ margin: "15px 0px" }}
              autoComplete="off"
              inputProps={{
                autoComplete: "off",
                autoCorrect: "off",
                spellCheck: "false",
              }}
              value={this.state.tempClientId}
              onChange={(e) => this.setState({ tempClientId: e.target.value })}
            />
            {this.state.errors?.clientId && (
              <span
                style={{
                  color: "red",
                  fontSize: "13px",
                  marginBottom: "4px",
                  display: "block",
                }}
              >
                {this.state.errors.clientId}
              </span>
            )}
            <TextField
              margin="dense"
              label="Client Secret"
              name="shopify_client_secret"
              fullWidth
              boxShadow="none"
              style={{ margin: "15px 0px" }}
              autoComplete="new-password"
              value={this.state.tempSecretId}
              onChange={(e) => this.setState({ tempSecretId: e.target.value })}
              type={this.state.showSecretId ? "text" : "password"}
              inputProps={{
                autoComplete: "new-password",
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() =>
                        this.setState({ showSecretId: !this.state.showSecretId })
                      }
                    >
                      {this.state.showSecretId ? (
                        <Visibility />
                      ) : (
                        <VisibilityOff />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            {this.state.errors?.secretId && (
              <span
                style={{
                  color: "red",
                  fontSize: "13px",
                  marginBottom: "4px",
                  display: "block",
                }}
              >
                {this.state.errors.secretId}
              </span>
            )}
            </form>
            <Box display="flex" alignItems="center" gap={1}>
              <Typography
                variant="p"
                style={{
                  fontStyle: "italic",
                  fontSize: "14px",
                  marginTop: "20px",
                  textTransform: "none",
                  color: "#000",
                }}
              >
                Note: Please ensure that the shop name you provide matches
                exactly with the <b>store name</b> where you have installed our
                app.
              </Typography>
            </Box>
          </DialogContent>
          <DialogActions
            style={{ padding: "25px", justifyContent: "center", gap: "15px" }}
          >
            <Button
              type="button"
              variant="contained"
              color="inherit"
              onClick={this.handleCloseShopifyDialog}
            >
              Cancel
            </Button>
            <Button
              className="primary-bg color-white"
              variant="contained"
              color="primary"
              disabled={this.state.isSavingShopify}
              onClick={this.handleSaveShopify}
            >
              {this.state.isSavingShopify ? (
                <CircularProgress size={22} color="inherit" />
              ) : (
                "Save"
              )}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={this.state.isValidatingShopify}>
          <DialogContent
            style={{ textAlign: "center", padding: 30, width: 400 }}
          >
            <CircularProgress />
            <Typography className="text-primary">Validating...</Typography>
          </DialogContent>
        </Dialog>

        <Dialog
          open={this.state.openSetupModal}
          onClose={() => this.setState({ openSetupModal: false })}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Complete App Setup Required</DialogTitle>
          <DialogContent>
            <p>
              Before configuring your shop details, please make sure you have
              completed the app setup (ignore this message if it's already
              done).
            </p>
            <p style={{ marginTop: 15 }}>
              If not, complete it by clicking the <b>Complete App Setup</b>{" "}
              button or from the top-right three-dot menu.
            </p>
          </DialogContent>
          <DialogActions>
            <Button
              className="void-status"
              onClick={() => {
                this.setState({ openSetupModal: false });
                this.handleAppSetup();
              }}
            >
              Complete App Setup
            </Button>
            <Button
              className="primary-bg color-white"
              onClick={() =>
                this.setState({
                  openSetupModal: false,
                  openShopifyDialog: true,
                  tempShopName: this.state.shopname || "",
                  tempClientId: this.state.shopify_client_id || "",
                  tempSecretId: this.state.shopify_client_secret || "",
                  errors: {},
                  showClientId: false,
                  showSecretId: false,
                })
              }
            >
              Continue
            </Button>
            <Button
              variant="contained"
              color="inherit"
              onClick={() => this.setState({ openSetupModal: false })}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.openPasswordDialog}
          onClose={this.handleClosePasswordDialog}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            style: {
              overflow: "hidden",
            },
          }}
        >
          <DialogContent style={{ padding: "0px" }}>
            <Paper
              elevation={0}
              style={{
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  background: "#383838",
                  padding: "18px",
                  textAlign: "center",
                }}
              >
                <p
                  style={{
                    color: "#fff",
                    // fontWeight: "bold",
                    margin: 0,
                    fontSize: "20px",
                  }}
                >
                  Change Password
                </p>
              </div>

              <div style={{ padding: "30px" }}>
                <Typography className="password-label">
                  Current Password
                </Typography>
                <TextField
                  fullWidth
                  required
                  name="currentPassword"
                  type={this.state.showPassword.current ? "text" : "password"}
                  placeholder="Enter current password"
                  value={this.state.form.currentPassword}
                  onChange={this.handleChange}
                  error={!!this.state.errors.currentPassword}
                  variant="outlined"
                  InputProps={{
                    style: {
                      borderRadius: "10px",
                      height: "45px",
                      fontSize: "14px",
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => this.togglePassword("current")}
                        >
                          {this.state.showPassword.current ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />

                {this.state.errors.currentPassword && (
                  <span
                    style={{
                      color: "red",
                      fontSize: "12px",
                    }}
                  >
                    {this.state.errors.currentPassword}
                  </span>
                )}

                <Typography className="password-label">New Password</Typography>

                <TextField
                  fullWidth
                  required
                  name="newPassword"
                  type={this.state.showPassword.new ? "text" : "password"}
                  placeholder="Enter new password"
                  value={this.state.form.newPassword}
                  onChange={this.handleChange}
                  error={!!this.state.errors.newPassword}
                  variant="outlined"
                  style={{ marginBottom: "10px" }}
                  InputProps={{
                    style: {
                      borderRadius: "10px",
                      height: "45px",
                      fontSize: "14px",
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => this.togglePassword("new")}>
                          {this.state.showPassword.new ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />

                {this.state.errors.newPassword && (
                  <span
                    style={{
                      color: "red",
                      fontSize: "12px",
                    }}
                  >
                    {this.state.errors.newPassword}
                  </span>
                )}

                <Typography className="password-label">
                  Confirm New Password
                </Typography>

                <TextField
                  fullWidth
                  required
                  name="confirmPassword"
                  type={this.state.showPassword.confirm ? "text" : "password"}
                  placeholder="Confirm new password"
                  value={this.state.form.confirmPassword}
                  onChange={this.handleChange}
                  error={!!this.state.errors.confirmPassword}
                  variant="outlined"
                  style={{ marginBottom: "10px" }}
                  InputProps={{
                    style: {
                      borderRadius: "10px",
                      height: "45px",
                      fontSize: "14px",
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => this.togglePassword("confirm")}
                        >
                          {this.state.showPassword.confirm ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />

                {this.state.errors.confirmPassword && (
                  <span
                    style={{
                      color: "red",
                      fontSize: "12px",
                    }}
                  >
                    {this.state.errors.confirmPassword}
                  </span>
                )}

                {/* Buttons */}
                <div
                  style={{
                    marginTop: "30px",
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "15px",
                  }}
                >
                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: "#CEA05F",
                      color: "#fff",
                      borderRadius: "8px",
                      padding: "10px 24px",
                      textTransform: "none",
                      fontWeight: "bold",
                      boxShadow: "none",
                    }}
                    disabled={this.state.loading}
                    onClick={this.handleSubmitPassword}
                  >
                    Change Password
                    {this.state.loading && (
                      <CircularProgress
                        size={20}
                        style={{
                          color: "#fff",
                          marginLeft: "10px",
                        }}
                      />
                    )}
                  </Button>

                  <Button
                    variant="outlined"
                    style={{
                      borderRadius: "8px",
                      padding: "10px 24px",
                      textTransform: "none",
                      borderColor: "#ccc",
                      color: "#333",
                    }}
                    onClick={this.handleClosePasswordDialog}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </Paper>
          </DialogContent>
        </Dialog>
      </div>
    );
  }

  render() {
    return (
      <div>
        <ContentWrapper
          contentView={this.renderProfileDetails()}
        ></ContentWrapper>
      </div>
    );
  }
}

function mapStateToProps({ InventoryList, dealer, auth }) {
  return {
    countryListInfo: InventoryList.countryList,
    userInfo: InventoryList.userInfo,
    accountdetails: InventoryList.accountdetails,
    activePackagesListInfo: dealer.activePackagesListInfo,
    currentUser: auth.currentUser,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      countriesList,
      getuser,
      getaccountdetails,
      activePackageList,
      getBusinessInfo,
      updateProfilePic,
    },
    dispatch,
  );
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProfileComponent),
);
